export default "__VITE_ASSET__WHBas0zg__"